// v-fit-photo: a listing photo normally fills its frame (object-fit: cover), which
// crops. For a painting or a tall print that cuts off too much, so when filling would
// lose more than CROP_LIMIT of the picture the whole picture is shown instead
// (data-fit="whole"; the frame's background shows at the sides). Client-only: the
// server renders "fill", the browser adjusts once the picture's size is known.
export const CROP_LIMIT = 0.12;

// Share of the picture that "cover" would cut off, 0 when the shapes match.
export const cropShare = (imgW, imgH, boxW, boxH) => {
    if (!(imgW > 0 && imgH > 0 && boxW > 0 && boxH > 0)) return 0;
    const a = imgW / imgH;
    const b = boxW / boxH;
    return 1 - Math.min(a / b, b / a);
};

const apply = (el) => {
    const share = cropShare(el.naturalWidth, el.naturalHeight, el.clientWidth, el.clientHeight);
    if (share > CROP_LIMIT) el.setAttribute('data-fit', 'whole');
    else el.removeAttribute('data-fit');
};

const watch = (el) => {
    if (el.complete && el.naturalWidth) apply(el);
    else el.addEventListener('load', () => apply(el), {once: true});
};

export const fitPhoto = {
    mounted: watch,
    updated(el, binding, vnode, prev) {
        if (prev?.props?.src !== vnode.props?.src) watch(el);
    },
};
